import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Main from './Main';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlug, faMicrochip, faWaveSquare, faBrain, faDatabase, faRobot, faNetworkWired, faLaptopMedical, faFileInvoiceDollar, faSatellite, faCode, faRedo, faPlay, faStop } from '@fortawesome/free-solid-svg-icons';
import { csv } from 'd3-fetch';

library.add(faPlug, faMicrochip, faWaveSquare, faBrain, faDatabase, faRobot, faNetworkWired, faLaptopMedical, faFileInvoiceDollar, faSatellite, faCode, faRedo, faPlay, faStop );

ReactDOM.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>,
  document.getElementById('page')
);

export function peoplePromise() {
  if (!window.peoplePromise) {
    window.peoplePromise = csv("./data/people_v2.csv");
    window.peoplePromise.then(data => {
      for (let i=0; i< data.length; i++)
        if (data[i]["Fotó"] === "")
          data[i]["Fotó"] = "unknown.png"
      window.people = data;
    });
  }        
  return window.peoplePromise;
}
